
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  function addToCartCustom(params){
    flitsSnackbar.show({ text: Flits.t("Flits.locals.cart_page.adding_items_to_cart", "Adding items to cart..."), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default flits-alert-custom", duration: !1 }),
      Flits.ajax({ type: "POST", url: "/cart/add.js", data: params, dataType: "json" })
    .done(function (resp) {
        Flits.flitsSnackbarHide();
        Flits.getJSON('/cart.js', function(cart) {
          
          if(Flits(".header-container .toolbar-icons .current-cart-count .inner-count").length > 0){
            Flits(".header-container .toolbar-icons .current-cart-count .inner-count").text(cart.item_count);
          }else{
          var cartCount = '<span class="current-cart-count"><span class="inner-count">'+cart.item_count+'</span></span>';
            Flits(".header-container .toolbar-icons .current-cart-icon.current-cart-icon--cart").append(cartCount)
          }
          
           flitsSnackbar.show({
                text: Flits.t('Flits.locals.cart_page.added_to_cart', 'Product(s) Added to the cart.'),
                pos: 'bottom-center',
                showAction: false,
                customClass: 'flits-alert-success',
                duration: 2000
            });
        });
      // Flits.getJSON('/cart.js', function(cart) {
      //     Flits(".header-container .toolbar-icons .current-cart-count .inner-count").text(cart.item_count);
      //   });
       // flitsSnackbar.show({ text: resp.responseJSON.description, pos: "bottom-center", showAction: !1, customClass: "flits-alert-error" });
     
      //location.reload();
    })
    .fail(function (resp) {
      flitsSnackbar.show({ text: resp.responseJSON.description, pos: "bottom-center", showAction: !1, customClass: "flits-alert-error" });
    })
    .always(function () {});
  }
   Flits(document).on('click', '.flits-add-to-cart', (function(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        let el = Flits(this);
            let quantity = parseInt(Flits(el).parents('.flits-product-card').find('input[name="product_quantity_input"]').val());
            let maxLimit = parseInt(Flits(el).parents('.flits-product-card').find('input[name="product_quantity_input"]').attr('max'));
            let id = Flits(el).parents('.flits-product-card').find('.flits-variant-select').val();
            let interval = 0;
            if (cartOrder[id]) {
                if (quantity + parseInt(cartOrder[id].cart_quantity) > maxLimit) {
                    quantity = maxLimit - parseInt(cartOrder[id].cart_quantity);
                    quantity == 0 ? quantity = maxLimit : quantity;
                    interval = 3000;
                    flitsSnackbar.show({
                        text: Flits.t('Flits.locals.general.cart_updated', 'Some items are no longer available. Your cart has been updated.'),
                        pos: 'bottom-center',
                        showAction: false,
                        customClass: 'flits-alert-default'
                    })
                }
            }
            let data = "id=" + id + "&quantity=" + quantity;
            setTimeout((function() {
                addToCartCustom(data)
            }
            ), interval)
        }
        ));
}(Flits));
